export default __webpack_public_path__ + "static/media/firefox.72df3153.svg";